import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {
    AiFillTwitterCircle,
    AiFillGithub,
    AiFillLinkedin,
    AiFillYoutube,
} from "react-icons/ai";
import {GrMail} from "react-icons/gr";
import Footer from "../custom/Footer";
import MobNavbar from "../custom/MobNavbar";

import "./Homepage.css";

function Homepage(props) {
    const pagewidth = window.innerWidth;
    const [small, setsmall] = useState(false);
    useEffect(() => {
        if (pagewidth <= 960) {
            setsmall(true);
        } else if (pagewidth > 960) {
            setsmall(false);
        }
    }, small);

    return (
        <>
            {/* {!small && ( */}
            <>
                <div
                    style={{
                        backgroundColor: props.darkMode ? "rgb(17 24 39)" : "darkcyan",
                    }}
                    className="home"
                    id="home"
                >
                    <div className="div1">
                        <h2>Hello There! I'm Gaurav</h2>
                        <br/>
                        <br/>
                        <h1>Full Stack Web Developer</h1>
                        <br/>
                        <h4>
                            With a strong foundation in the MERN stack &<br/> a proven
                            track record of successful projects,
                            <br/>
                            I am confident in my abilities to deliver
                            <br/> exceptional results
                        </h4>
                        <br/>
                        <h4>Join me down below and let's get cracking!</h4>
                        <br/>
                        <div className="socioicons">
                            <a href="https://github.com/gaurav-iitb" target="_blank">
                                <AiFillGithub id="socio1"/>
                            </a>
                            <a href="https://www.linkedin.com/in/gaurav-sharma-93b9b0207/" target="_blank">
                                <AiFillLinkedin id="socio1"/>
                            </a>
                            <a href="mailto:200010026@iitb.ac.in " target="_blank">
                                <GrMail id="socio1"/>
                            </a>
                        </div>
                    </div>
                    <div className="div2">
                        {/*  <img className="custimg" src="./my-pic.png" alt="myphoto" />*/}
                        <div className="bg-gradient-to-b">
                            <img className="custimg" src="./my-pic.png"/>
                        </div>
                    </div>
                </div>
            </>

            {/* {small && (
        <div>
          <div class="top-box">
            <div class="second">
              <div class="surr-img">
                <img class="my-img" src="./my-pic.png" alt="" />
              </div>
              <h1 class="name-h1">
                Hi, I am
                <br />
                Gaurav
              </h1>
              <h3 className="name-h3">
                Competitive Programmer
                <br />
                Full Stack Developer
              </h3>
              <p class="description">
                I am very flexible and adaptive to learn new things.I like to
                challenge myself on a regular basis.
              </p>
            </div>
          </div>
          <div class="third">
            <Link style={{ textDecoration: "none" }} to="/ContactUs">
              <p class="inner-para">
                Hire Me
                <i class="fa-solid fa-comment ic" />
              </p>
            </Link>
          </div>
        </div>
      )} */}
        </>
    );
}

export default Homepage;
